/* eslint-disable jira/filename-case */
import { COMMON_ANALYTICS_ATTRIBUTES as BASE_COMMON_ANALYTICS_ATTRIBUTES } from '../../common/constants.tsx';

export const COMMON_ANALYTICS_ATTRIBUTES: {
	section: string;
	actionSubjectId: string;
	componentType: string;
	level: number;
	settingsGroup: string;
} = {
	...BASE_COMMON_ANALYTICS_ATTRIBUTES,
	section: 'plans',
};
